module.exports = __webpack_public_path__ + "img/table.d172bcab.svg";